import React, {useEffect, useState} from "react";
import "./BalancePage.sass";
import StudentGrid from "../../../_components/student/StudentGrid";
import {useDispatch, useSelector} from "react-redux";
import ButtonComponent from "../../../_components/common/buttons/ButtonComponent";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import {Paper, TableContainer} from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {StyledTableCell, StyledTableRow} from "../../../_components/TableComponents";
import TableBody from "@mui/material/TableBody";
import {deletePayment, getPayments, sendReceipt} from "../../../_actions/receipt/receiptService";
import {FAILED, IDLE, LOADING, SUCCESS} from "../../../common/statuses";
import {paymentType} from "./PaymentHelper";
import moment from "moment";
import _ from "lodash";
import {useSnackbar} from "notistack";
import DialogComponent from "../../../_components/common/dialog/DialogComponent";
import {ADDRESS} from "../../../_api/client";
import Spinner from "../../common/anonymous/Spinner";
import {clearReceiptState} from "../../../_actions/receipt/receipReducer";
import {green, red} from "../../../common/colors";

export default function BalancePage() {
    const [description, setDescription] = useState();

    const {courses} = useSelector(state => state.auth.current)
    const {message: loadMessage, status: loadStatus} = useSelector(state => state.payments.loadReceipt)
    const {data, status} = useSelector(state => state.payments.getPayments);
    const {message: deleteMessage, status: deleteStatus} = useSelector(state => state.payments.deletePayment);

    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar()

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getPayments());
        }
    }, [data, status, dispatch])
    useEffect(() => {
        if (loadStatus === SUCCESS) {
            enqueueSnackbar(loadMessage, {variant: "success"})
            dispatch(clearReceiptState())
        }
        if (loadStatus === FAILED) {
            enqueueSnackbar(loadMessage, {variant: "error"})
        }
    }, [loadStatus, loadMessage, dispatch])
    useEffect(() => {
        if (deleteStatus === SUCCESS) {
            enqueueSnackbar(deleteMessage, {variant: "success"})
            setDescription(null)
            dispatch(clearReceiptState())
        }
        if (deleteStatus === FAILED) {
            enqueueSnackbar(deleteMessage, {variant: "error"})
            setDescription(null)
        }
    }, [deleteStatus, deleteMessage, dispatch])
    useEffect(() => {
        document.title = 'КьюАй - Баланс'
        return () => {
            dispatch(clearReceiptState())
        }
    }, [])

    if (status === IDLE || status === LOADING
        || loadStatus === LOADING
        || deleteStatus === LOADING) {
        return <Spinner/>
    }

    const buttonStyle = {
        backgroundColor: 'rgb(85, 204, 120)',
        display: 'flex',
        gap: '1em',
        alignItems: 'center'
    }

    const handleSentReceipt = (event) => {
        if (event.target.files && event.target.files[0]) {
            let formData = new FormData();
            formData.append("file", event.target.files[0]);

            dispatch(sendReceipt(formData));
        }
    }

    const handleRemovePayment = () => {
        dispatch(deletePayment(description.id));
    }

    const renderDescription = () => {
        if (description) {
            const {id, confirmDate, receipt, type, student, acceptor, amount, lesson} = description


            const buttons = {
                accept: confirmDate ? undefined : "Удалить",
                cancel: "Закрыть",
            }

            const renderContent = () => {
                if (type === "RECEIPT") {
                    return <div className="BalancePage-dialog-receipt">
                        <img src={`${ADDRESS}/receipt/file/${receipt.id}`} alt={receipt.name}/>
                    </div>
                } else {
                    const teacherName = `${acceptor.lastName} ${acceptor.firstName} ${acceptor.middleName ? acceptor.middleName : ""}`

                    const getDescription = () => {
                        if (type === "LESSON") {
                            return <span>
                                Ваш учитель <i>{teacherName}</i> отметил ваше присутствие на уроке <i>{lesson.group.course.name}</i>, дата и время проведения урока: <i>{moment(`${lesson.date}T${lesson.time}`, "YYYY-MM-DDTHH-mm-SS").format("DD.MM.YYYY в HH:mm")}</i>
                            </span>
                        }
                        if (type === "RETURN_LESSON") {
                            return <span>
                                Ваш учитель <i>{teacherName}</i> отменил ваше присутствие на уроке <i>{lesson.group.course.name}</i>, дата и время проведения урока: <i>{moment(`${lesson.date}T${lesson.time}`, "YYYY-MM-DDTHH-mm-SS").format("DD.MM.YYYY в HH:mm")}</i>
                            </span>
                        }
                    }

                    return <div className="BalancePage-dialog">
                        <div>Тип операции:</div>
                        <div>{paymentType[type]}</div>
                        <div>Дата создания:</div>
                        <div>{moment(`${confirmDate}`, "YYYY-MM-DDTHH-mm-SS").format("DD.MM.YYYY в HH:mm")}</div>
                        <div>Ученик:</div>
                        <div>{`${student.lastName} ${student.firstName} ${student.middleName ? student.middleName : ""}`}</div>
                        <div>Учитель:</div>
                        <div>{teacherName}</div>
                        <div>{type === "LESSON" ? "Сумма списания:" : "Сумма возврата:"}</div>
                        <div>{(parseInt(amount) / 100).toFixed(2)} рублей</div>
                        <div>Урок:</div>
                        <div>{moment(`${lesson.date}T${lesson.time}`, "YYYY-MM-DDTHH-mm-SS").format("DD.MM.YYYY в HH:mm")}</div>
                        <div>Курс:</div>
                        <div>{lesson.group.course.name}</div>
                        <div>Причина:</div>
                        <div>{getDescription()}</div>
                    </div>
                }
            }

            return <DialogComponent title={`Описание платежа № ${id}`}
                                    buttons={buttons}
                                    open={!!description}
                                    onAccept={!confirmDate ? handleRemovePayment : undefined}
                                    onClose={() => setDescription(null)}>
                {renderContent()}
            </DialogComponent>
        }

    }

    const renderAmount = (amount, type) => {
        if (!amount) {
            return "-"
        }
        let result;
        let style = {};

        switch (type) {
            case "CHANGE_BALANCE": {
                result = `${(parseInt(amount) / 100).toFixed(2)} руб.`;
                break;
            }
            case "LESSON": {
                style.color = red;
                result = `-${(parseInt(amount) / 100).toFixed(2)} руб.`;
                break;
            }
            default: {
                style.color = green;
                result = `+${(parseInt(amount) / 100).toFixed(2)} руб.`
                break;
            }
        }

        return <div style={style}>
            {result}
        </div>
    }

    const renderInitDate = ({confirmDate, receipt, type}) => {
        if (type === "RECEIPT") {
            return moment(receipt.sendDate, "YYYY-MM-DDTHH-mm-SS").calendar()
        }
        return moment(`${confirmDate}`, "YYYY-MM-DDTHH-mm-SS").calendar()
    }

    return <div className="BalancePage-wrapper">
        <StudentGrid/>
        <div className="BalancePage-tab-wrapper">
            <div className="BalancePage-title">
                <div/>
                <div className="BalancePage-title-text">История баланса</div>
                {
                    !_.isEmpty(courses) &&
                    <ButtonComponent style={buttonStyle}
                                     component="label">
                        <input hidden
                               onChange={handleSentReceipt}
                               accept=".jpg,.jpeg"
                               type="file"/>
                        <span><ReceiptLongIcon/></span>
                        <span>Добавить чек об оплате</span>
                    </ButtonComponent>
                }
            </div>
            <div className="BalancePage-table-wrapper">
                <TableContainer component={Paper}>
                    <Table>
                        <caption>{loadStatus === LOADING && "Загрузка..."}</caption>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell></StyledTableCell>
                                <StyledTableCell>Дата создания</StyledTableCell>
                                <StyledTableCell>Сумма</StyledTableCell>
                                <StyledTableCell>Операция</StyledTableCell>
                                <StyledTableCell>Дата подтверждения</StyledTableCell>
                                <StyledTableCell>Статус</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        {data &&
                            <TableBody>
                                {data.map((payment) => {
                                    const {id, confirmDate, amount, receipt, type} = payment

                                    return (
                                        <StyledTableRow key={`request-${id}`}
                                                        onClick={() => type !== "CHANGE_BALANCE" ? setDescription(payment) : (() => {})}>
                                            <StyledTableCell scope="row">
                                                {receipt && <ReceiptLongIcon style={{color: "#28ade0"}}/>}
                                            </StyledTableCell>
                                            <StyledTableCell scope="row">
                                                {renderInitDate(payment)}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {renderAmount(amount, type)}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <div>
                                                    {paymentType[type]}
                                                </div>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {confirmDate ? moment(confirmDate, "YYYY-MM-DDTHH-mm-SS").calendar() : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {confirmDate ? "Обработано" : "В обработке"}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )
                                })}
                            </TableBody>
                        }
                    </Table>
                </TableContainer>
            </div>
        </div>
        {renderDescription()}
    </div>

}